module.exports = __webpack_public_path__ + "static/media/circle.b1b018a6.svg";